function injectStyle (ssrContext) {
  require("!!../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-1592ef42\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!../../../../node_modules/string-replace-webpack-plugin/loader.js?id=pnre6zws23l!../../../../node_modules/string-replace-webpack-plugin/loader.js?id=hfo8n7cvtpt!./Categories.vue")
}
var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!../../../../node_modules/string-replace-webpack-plugin/loader.js?id=pnre6zws23l!../../../../node_modules/string-replace-webpack-plugin/loader.js?id=hfo8n7cvtpt!./Categories.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-1592ef42\",\"hasScoped\":true}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!../../../../node_modules/string-replace-webpack-plugin/loader.js?id=pnre6zws23l!../../../../node_modules/string-replace-webpack-plugin/loader.js?id=hfo8n7cvtpt!./Categories.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1592ef42",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/ecommerce/filter/Categories.vue
// module id = 609
// module chunks = 0